import MissionDashboardV2 from './MissionDashboardV2';
import MissionDetails from './MissionDetails';
import { useFeatureFlag } from '../../contexts/FeatureFlagsProvider';

/**
 * Point d'entrée de la route `/missions-freelance/:id`. Bascule entre la nouvelle fiche mission V2
 * (feature flag `missionDashboardV2`) et la V1 historique (`MissionDetails`). Par défaut : V1.
 * Le flag est lu au render (contexte), donc l'activer dans les Paramètres bascule sans rebuild.
 */
const MissionRoutePage = () => {
  const missionDashboardV2 = useFeatureFlag('missionDashboardV2');
  return missionDashboardV2 ? <MissionDashboardV2 /> : <MissionDetails />;
};

export default MissionRoutePage;
